/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Assistant_Agent_ResetsInputs */



/**
* | output |
* | --- |
* | "resets {date}" |
*
* @param {Assistant_Agent_ResetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_resets = /** @type {((inputs: Assistant_Agent_ResetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_ResetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`réinitialise ${i?.date}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`setzt ${i?.date} zurück`)
	if (locale === "it") return /** @type {LocalizedString} */ (`ripristina ${i?.date}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`сбрасывает ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`restablece ${i?.date}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`重置 ${i?.date}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.date}をリセットします`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.date} को रीसेट करता है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`redefine ${i?.date}`)
	return /** @type {LocalizedString} */ (`resets ${i?.date}`)
});